import { render, staticRenderFns } from "./CommunityUnitBusinessNews.vue?vue&type=template&id=65aafe7e&scoped=true"
import script from "./CommunityUnitBusinessNews.vue?vue&type=script&lang=js"
export * from "./CommunityUnitBusinessNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aafe7e",
  null
  
)

export default component.exports